import React, { useState } from "react";
import { Button, FormFooter } from "xsolla-uikit";
import { ProductIcon } from "../../data/ProductIcon";
import { PAmodal } from "../PApop";
import { PAconnectorChatSlackInner } from "./PAconnectorChatSlackInner";
export const ConnectSlack = ({ appearance = "md", header = "Connect Xsolla to your Slack", icon = "slack", text = "Connector Description", connected = false, submitActive = false, footer = true, valid = false, children, }) => {
  const [state, setState] = useState({
    connected: connected,
    pop: false,
  });
  const handleModal = () => {
    setState({
      pop: false,
    });
  };
  const handleConnect = () => {
    setState({
      connected: true,
    });
  };
  return (<div style={{ justifySelf: "stretch" }}>
    {state.pop && (<PAmodal closeButton={false} size={appearance} header={header} handleModal={handleModal} handleConnect={handleConnect} submitActive={submitActive} footer={<FormFooter>
      <Button appearance="outline" onClick={() => {
        handleModal();
      }}>
        Discard
              </Button>
      <Button appearance="primary" disabled={submitActive ? false : true} onClick={() => {
        handleModal();
        handleConnect();
      }}>
        Connect
              </Button>
    </FormFooter>}>
      <PAconnectorChatSlackInner />
    </PAmodal>)}

    <div className="gateway-card gateway-card--click-enabled" style={{ height: "100%", width: "auto" }} onClick={() => {
      setState({
        // connected: !state.connected,
        pop: !state.pop,
      });
    }}>
      <div style={{ padding: "16px 16px 16px 16px", display: "flex" }}>
        <div style={{ flexGrow: 1 }}>
          <p className="ui-form__input-description">{header}</p>
        </div>

        <ProductIcon
          // size="xs"
          width={24} height={24} name={icon} />
      </div>



      <div className="gateway-card__delimiter" />
      <div className="gateway-card__content">
        <div className="gateways-list__item-panel">
          <span className="gateways-list__item-panel-configure">
            <div className="gateways-list__item-panel-configure-shape" />

            <Button appearance="flatten">
              {!state.connected && `Connect`}
              {state.connected && (<span class="card-app__action_connected">Connected</span>)}
            </Button>
          </span>
        </div>
      </div>
    </div>
  </div>);
};
